<div class="shipping-component">
  <form class="shipping-form" [formGroup]="shippingForm">
    <div class="row two">
      <label>Submitters Email <span class="required">*</span>
        <input type="email" formControlName="submitterEmail" placeholder="email@company.com"
          [class.invalid-field]="isInvalid('submitterEmail')">
        <cx-form-errors [control]="shippingForm.get('submitterEmail')"></cx-form-errors>
      </label>
    </div>

    <div class="row two">
      <label>First Name <span class="required">*</span>
        <input type="text" formControlName="firstName" [class.invalid-field]="isInvalid('firstName')">
        <cx-form-errors [control]="shippingForm.get('firstName')"></cx-form-errors>
      </label>
      <label>Last Name <span class="required">*</span>
        <input type="text" formControlName="lastName" [class.invalid-field]="isInvalid('lastName')">
        <cx-form-errors [control]="shippingForm.get('lastName')"></cx-form-errors>
      </label>
    </div>

    <div class="row one">
      <label class="full-input">Company Name <span class="required">*</span>
        <input class="full-input-input" type="text" formControlName="company"
          [class.invalid-field]="isInvalid('company')">
        <cx-form-errors [control]="shippingForm.get('company')"></cx-form-errors>
      </label>
       @if (isLabels) {
      <label class="full-input">Plant Location <span class="required">*</span>
        <ng-select [items]="plantLocationList" bindLabel="plantName" bindValue="plantId"
          formControlName="plantLocation" (change)="selectPlantLocation()" [class.invalid-field]="isInvalid('plantLocation')">
        </ng-select>
        <cx-form-errors [control]="shippingForm.get('plantLocation')"></cx-form-errors>
      </label>
    }
    </div>

    <div class="row one">
      <label class="full-input">Street Address 1 <span class="required">*</span>
        <input class="full-input-input" type="text" formControlName="street1"
          [class.invalid-field]="isInvalid('street1')">
        <cx-form-errors [control]="shippingForm.get('street1')"></cx-form-errors>
      </label>
    </div>

    <div class="row one">
      <label class="full-input">Street Address 2 <span class="required">*</span>
        <input class="full-input-input" type="text" formControlName="street2"
          [class.invalid-field]="isInvalid('street2')">
        <cx-form-errors [control]="shippingForm.get('street2')"></cx-form-errors>
      </label>
    </div>

    <div class="row three">
      <label>City <span class="required">*</span>
        <input type="text" formControlName="city" [class.invalid-field]="isInvalid('city')">
        <cx-form-errors [control]="shippingForm.get('city')"></cx-form-errors>
      </label>
      <label>State/Province/District <span class="required">*</span>
        <ng-select [items]="this.stateList" bindLabel="name" bindValue="isocode" formControlName="state">
        </ng-select>
        <cx-form-errors [control]="shippingForm.get('state')"></cx-form-errors>
      </label>
      <label>ZIP / Postal Code <span class="required">*</span>
        <input type="text" formControlName="postal" maxlength="5" [class.invalid-field]="isInvalid('postal')">
        <cx-form-errors [control]="shippingForm.get('postal')"></cx-form-errors>
      </label>
    </div>

    <div class="row three">
      <label>Country / Region <span class="required">*</span>
        <ng-select [class.invalid-field]="isInvalid('country')" [items]="this.usaCanadaMexicoCountryList"
          bindLabel="name" bindValue="isocode" (change)="countrySelected($event, 'shipping')" formControlName="country"
          [ngModel]="defaultedCountry" [loading]="isCountryLoading">
        </ng-select>
        <cx-form-errors [control]="shippingForm.get('country')"></cx-form-errors>
      </label>
      <label>Phone <span class="required">*</span>
        <input type="text" formControlName="phone" [class.invalid-field]="isInvalid('phone')"
          (input)="formatPhoneNumber()" placeholder="(123) 456-7890">
        <cx-form-errors [control]="shippingForm.get('phone')"></cx-form-errors>
      </label>
    </div>
     @if (!isLabels) {
    <div class="row three overnight-note-border"></div>
    <div class="row one overnight-note-text">
      <b>Note:</b> All orders shipped standard ground unless Overnight Shipping selected.
      <span>A UPS or FedEx acct # is required for Overnight Shipping and order must be submitted by 1:00 pm eastern
        time.</span>
    </div>
    <div class="row one">
      <label><span class="overnight-shipping-text">Would you like Overnight Shipping?</span>
        <input type="checkbox" formControlName="overnight" class="overnight-shipping-checkbox">
      </label>
    </div>
    @if(showOvernight){
    <div>
      <div class="row two">
        <label>Select Overnight Carrier <span class="required">*</span>
          <select formControlName="overnightCarrier" [class.invalid-field]="isInvalid('overnightCarrier')">
            <option value="">Select carrier</option>
            <option>UPS</option>
            <option>FedEx</option>
          </select>
          <cx-form-errors [control]="shippingForm.get('overnightCarrier')"></cx-form-errors>
        </label>
        <label>Account Number <span class="required">*</span>
          <input type="text" formControlName="overnightAccountNumber"
            [class.invalid-field]="isInvalid('overnightAccountNumber')">
          <cx-form-errors [control]="shippingForm.get('overnightAccountNumber')"></cx-form-errors>
        </label>
      </div>
      <div class="row one">
        <h4>Billing Address</h4>
      </div>

      <div class="row two">
        <label>Billing Name <span class="required">*</span>
          <input type="text" formControlName="billingName" [class.invalid-field]="isInvalid('billingName')">
          <cx-form-errors [control]="shippingForm.get('billingName')"></cx-form-errors>
        </label>
        <label>Address 1 <span class="required">*</span>
          <input type="text" formControlName="billingAddr1" [class.invalid-field]="isInvalid('billingAddr1')">
          <cx-form-errors [control]="shippingForm.get('billingAddr1')"></cx-form-errors>
        </label>
      </div>
      <div class="row two">
        <label>Address 2
          <input type="text" formControlName="billingAddr2">
        </label>
        <label>City <span class="required">*</span>
          <input type="text" formControlName="billingCity" [class.invalid-field]="isInvalid('billingCity')">
          <cx-form-errors [control]="shippingForm.get('billingCity')"></cx-form-errors>
        </label>
      </div>
      <div class="row two">
        <label>State/ Province/ District <span class="required">*</span>
          <ng-select [items]="this.overNightStateList" bindLabel="name" bindValue="isocode"
            formControlName="billingState">
          </ng-select>
          <cx-form-errors [control]="shippingForm.get('billingState')"></cx-form-errors>
        </label>
        <label>ZIP / Postal Code <span class="required">*</span>
          <input type="text" formControlName="billingPostal" maxlength="5"
            [class.invalid-field]="isInvalid('billingPostal')">
          <cx-form-errors [control]="shippingForm.get('billingPostal')"></cx-form-errors>
        </label>
      </div>      
      <div class="row two">
        <label>Country / Region <span class="required">*</span>
          <ng-select [class.invalid-field]="isInvalid('billingCountry')" [items]="this.usaCanadaMexicoCountryList"
            bindLabel="name" bindValue="isocode" (change)="countrySelected($event, 'overnight')"
            formControlName="billingCountry" [ngModel]="overNightDefaultedCountry" [loading]="isCountryLoading">
          </ng-select>
          <cx-form-errors [control]="shippingForm.get('billingCountry')"></cx-form-errors>
        </label>
      </div>
    </div>
    }
  }
    <div class="row one">
      <label class="full-input">Comments
        <textarea rows="3" formControlName="comments"
          placeholder="Enter any special instructions or comments..."></textarea>
      </label>
    </div>

  </form>
</div>